namespace $.$$ {
	$mol_style_define($bog_blitz_admin_option, {
		background: {
			color: $mol_theme.hover,
		},
		border: {
			radius: '0.25rem',
		},
		padding: {
			top: '0.25rem',
			bottom: '0.25rem',
			left: '0.5rem',
			right: '0.25rem',
		},
		Controls: {
			gap: '0.25rem',
		},
		Text: {
			flex: {
				grow: 1,
				shrink: 1,
			},
		},
		Delete: {
			color: '#cc3333',
		},
		Image_section: {
			align: {
				items: 'center',
			},
			gap: '0.5rem',
		},
		Image_upload: {
			Native: {
				top: 0,
				height: '100%',
			},
		},
		Image_preview: {
			maxHeight: '6rem',
			maxWidth: '10rem',
			border: {
				radius: '0.25rem',
			},
			overflow: 'hidden',
		},
	})
}
